import React from 'react';
import { useStyles as useDropdownMenuFilterStyles } from './DropdownMenuFilter.styles';
import { Menu, MenuItem, TextField, TextFieldProps } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface NumericRangePickerProps {
  anchorEl?: SVGSVGElement | HTMLElement | null;
  setAnchorEl: (closeElement: SVGSVGElement | HTMLElement | null) => void;
  firstValue: string;
  secondValue: string;
  onChange: (value: string, typeOfChange: 'from' | 'to' | 'clear') => void;
  component?: JSX.Element | null;
  noAnswerFilter?: JSX.Element | null;
  advancedFilter?: JSX.Element | null;
}

export const NumericRangePicker: React.FC<NumericRangePickerProps> = (props) => {
  const dropdownMenuClasses = useDropdownMenuFilterStyles();

  const poinstSumTextFieldsProps: TextFieldProps = {
    variant: 'outlined',
    placeholder: 'Wartość',
    type: 'number',
    margin: 'dense',
    inputProps: {
      min: 0,
      style: { width: '80px', fontSize: '16px' },
      'aria-label': 'zakres punktów',
    },
  };
  const handleClearFilter = () => {
    props.onChange('', 'clear');
    props.component?.props.onChange('', 'clear');
  };
  return (
    <Menu
      className={dropdownMenuClasses.dropdownMenuFilter}
      id="dropdown-menu-range-numeric"
      anchorEl={props.anchorEl}
      keepMounted
      open={Boolean(props.anchorEl)}
      onClose={() => props.setAnchorEl(null)}
    >
      <MenuItem disableRipple>
        <TextField
          label="Od"
          aria-label="zakres punktów - od"
          value={props.firstValue}
          style={{ paddingRight: '3px' }}
          {...poinstSumTextFieldsProps}
          onChange={(e) => props.onChange(e.target.value, 'from')}
        />
        <hr style={{ width: '8px' }} />
        <TextField
          label="Do"
          aria-label="zakres punktów - do"
          value={props.secondValue}
          style={{ paddingLeft: '3px' }}
          {...poinstSumTextFieldsProps}
          onChange={(e) => props.onChange(e.target.value, 'to')}
        />
      </MenuItem>
      {props.component}
      <MenuItem disableRipple>{props.noAnswerFilter}</MenuItem>
      {props.advancedFilter && <hr className={dropdownMenuClasses.hr} />}
      <MenuItem disableRipple>{props.advancedFilter}</MenuItem>
      <hr className={dropdownMenuClasses.hr} />
      <MenuItem disableRipple className={dropdownMenuClasses.filterCloseText} onClick={handleClearFilter}>
        <CloseIcon className={dropdownMenuClasses.filterListCloseIcon} />
        Wyczyść
      </MenuItem>
    </Menu>
  );
};
